/* eslint-disable jsx-a11y/anchor-is-valid */

/**
 * Renders a Quicklink
 * @returns {JSX.Element} The styled Link.
 * @param {any} props given by caller
 */


const Quicklink = props => {
    return (
        <>
            <a className="mfx-element-quicklink button button-border" id={props.designData.Link} onClick={() => props.onClickHandler('contact')} style={{ borderColor: props.designData.LinkColor }}>
                <i className={props.designData.LinkIcon + ' icons'}></i>
                {!isNaN(props.designData.Text) ? window.Dictionary.getTranslation(props.designData.Text) : props.designData.Text}
            </a>
        </>
    );
};

export default Quicklink;
